import React, { useEffect, useState } from 'react';
import {Image} from '@shopify/hydrogen';
import 'rc-slider/assets/index.css';
import arrowSearch from '../../../assets/image/arrow-search.svg';
import AZ from '../../../assets/image/search-icons/a-z.svg';
import ZA from '../../../assets/image/search-icons/z-a.svg';
import arrowDown from '../../../assets/image/search-icons/arrow-down.svg';
import arrowUp from '../../../assets/image/search-icons/arrow-up.svg';
import hurt from '../../../assets/image/search-icons/hurt.svg';
import start from '../../../assets/image/search-icons/start.svg';
import { useAppDispatch } from '../../../lib/hooks';
import { defineOrder, executeSearch } from '../../../store/slices/search';
import { sendEvent } from '../../../lib/analitycs';

export default function Order({}) {
  const dispatch = useAppDispatch();
  const [isActive, setIsActive] = useState(false);
  const [selectedOption, setSelectedOption] = useState('o_relevance=desc');

  const toggleOpen = ()=>{
    setIsActive(!isActive);
  }

  const chooseOrder = (order)=>{
    trackEvent(order);
    dispatch(defineOrder(order));
    dispatch(executeSearch());
    setSelectedOption(order);
  }

  const trackEvent = (order)=>{
    sendEvent('list_order',{
      list_option: order
    });
  }
  
  return (
    <>
      <div className="filter-item border-b px-10 py-3 box-order-content">
        <div 
          className={`
            accordion-header font-semibold text-lg flex justify-between cursor-pointer 
            ${!isActive ? 'accordion-close' : 'accordion-open'}
            `}
          onClick={toggleOpen}
        >
          <label> Ordenar </label>
          <Image
            src={arrowSearch}
            height={5}
            width={10}
            className="inline icon-arrow-down"
            alt="Search"
            style={{
              transform: isActive ? 'rotate(0deg)' : 'rotate(-90deg)',
            }}
          />
        </div>
        <div className={`
            accordion-content flex flex-wrap w-full order-options
            ${!isActive ? 'hidde-accordeon' : ''}
          `}>
            <div 
              className={`
                ${selectedOption === 'o_relevance=desc' ? 'option-choosen' : ''}
              `}
              onClick={()=>{chooseOrder('o_relevance=desc')}}
            >
              <label> Relevancia </label>
              <Image
                src={hurt}
                height={5}
                width={10}
                className="inline iconorder"
              />
            </div>
            <div 
              className={`
                ${selectedOption === 'o_date=desc' ? 'option-choosen' : ''}
              `}
              onClick={()=>{chooseOrder('o_date=desc')}}>
              <label> Más reciente </label>
              <Image
                src={start}
                height={5}
                width={10}
                className="inline iconorder"
              />
            </div>
            <div 
            className={`
              ${selectedOption === 'o_price=asc' ? 'option-choosen' : ''}
            `}
            onClick={()=>{chooseOrder('o_price=asc')}}>
              <label> Precio </label>
              <Image
                src={arrowUp}
                height={5}
                width={10}
                className="inline iconorder updown"
              />
            </div>
            <div 
            className={`
              ${selectedOption === 'o_price=desc' ? 'option-choosen' : ''}
            `}
            onClick={()=>{chooseOrder('o_price=desc')}}>
              <label> Precio </label>
              <Image
                src={arrowDown}
                height={5}
                width={10}
                className="inline iconorder updown"
              />
            </div>
            <div 
            className={`
              ${selectedOption === 'o_title=asc' ? 'option-choosen' : ''}
            `}
            onClick={()=>{chooseOrder('o_title=asc')}}>
              <label> Alfabético</label>
              <Image
                src={AZ}
                height={5}
                width={10}
                className="inline iconorder az"
              />
            </div>
            <div 
            className={`
              ${selectedOption === 'o_title=desc' ? 'option-choosen' : ''}
            `}            
            onClick={()=>{chooseOrder('o_title=desc')}}>
              <label> Alfabético </label>
              <Image
                src={ZA}
                height={5}
                width={10}
                className="inline iconorder az"
              />
            </div>
        </div>
      </div>
    </>
  );
}
